import ActiveRecord from './active_record/base'
import {t} from '@eitje/bridge'
import {i18n as I18n} from '@eitje/i18n'
import {date} from '@eitje/utils'
import utils from '@eitje/utils'
import moment from 'moment'

const ordinal = () => moment.localeData(I18n.language).ordinal
const monthday = d => `${t('common.the')}  ${ordinal()(d)} ${t('common.day')}`
const weekday = d => t(utils.weekdays[d])
const yearday = yearday => date().dayOfYear(yearday).format('DD MMM')

class ExportSubscription extends ActiveRecord {
	static tableName = 'export2Subscriptions'

	cronString() {
		const {mail_schedule} = this
		const {period, time} = mail_schedule

		const everyKey = period == 'year' ? 'elk' : 'every'

		const on = period != 'day' ? t('common.op') : ''
		const cronDay = period != 'day' ? this.cronDay() : ''

		return `${t(`common.${everyKey}`)} ${t(`common.${period}`)} ${on} ${cronDay} ${t('common.at')} ${time} `
	}

	cronDay() {
		const {mail_schedule} = this
		const {period, day_of_year, day_of_week, day_of_period, day_of_quarter, day_of_month} = mail_schedule
		const isPeriod = period == 'flex_wage_period' || period == 'hours_wage_period'
		if (period == 'week') return weekday(day_of_week)
		if (period == 'month' || isPeriod) return monthday(day_of_month || day_of_period)
		if (period == 'quarter') return monthday(day_of_quarter)
		if (period == 'year') return yearday(day_of_year)
	}

	exportAndMailNow() {
		return this.resourceReq('export_and_mail_now', {method: 'post'})
	}
}

export default ExportSubscription
